import { useEffect, useState } from 'react'
import { useDebounce } from 'use-debounce'
import useOffers from 'tennders-market/offer/hooks/useOffers'
import useSocket from 'tennders-common/hooks/useSocket'
import SingleOffer from 'tennders-market/offer/views/negotiation-for-shared/SingleOffer'
import FirstOffer from 'tennders-market/offer/views/negotiation-for-shared/FirstOffer'
import { REFRESH_TYPES } from 'tennders-common/stores/socket/action'
import useTranslation from 'next-translate/useTranslation'

const MarketPlaceOffer = ({ transaction, show, onToggle }) => {
  const { getMarketPlaceOffers } = useOffers()
  const { t } = useTranslation()
  const [sharedWith, setSharedWith] = useState([])
  const { refresh } = useSocket()
  const [offerCount, setOfferCount] = useState(0)
  const [debouncedRefresh] = useDebounce(refresh, 500)

  const init = async () => {
    const response = await getMarketPlaceOffers(transaction)
    if (Array.isArray(response)) {
      setSharedWith(response)
      setOfferCount(response.filter((sharedWith) => sharedWith.lastOffer || sharedWith.status?.label === 'OFFER_ACCEPTED_BY_NON_BROKER').length)
    }
  }

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    if (debouncedRefresh === 'offers' || debouncedRefresh === `${REFRESH_TYPES.TRANSACTION_OFFERS}-${transaction?.id}`) {
      init()
    }
  }, [debouncedRefresh])

  useEffect(() => {
    if (refresh === `${REFRESH_TYPES.TRANSACTION_OFFERS}-${transaction?.id}`) {
      init()
    }
  }, [refresh])

  useEffect(() => {
    if (offerCount > 0 && onToggle) {
      onToggle(true)
    }
  }, [offerCount])

  return (
    <>
      {transaction?.isSharedWithMarketPlace && (
        <h4 onClick={() => (onToggle ? onToggle(false) : null)} className="bold">
          {t('transaction:offersFrom')}
          {' '}
          {' Marketplace'}
          {' '}
          <span className="text-11 italic fw-normal">
            (
            {offerCount}
            {' '}
            {t('transaction:offers')})
          </span>
        </h4>
      )}
      {!transaction?.isSharedWithMarketPlace && <FirstOffer initialForm={null} transaction={transaction} />}
      <div
        style={show ? { display: 'block' } : { display: 'none' }}
        className="tennders-accordion-content carriers-documents-max-height tennders-custom-scroll mt-16"
      >
        {sharedWith.map((sw) => <SingleOffer marketPlace key={sw.id} transaction={transaction} offer={sw} />)}
      </div>
    </>
  )
}

export default MarketPlaceOffer
